
// import React, { useEffect, useState } from "react";
// import { Grid } from "@mui/material";
// import CustomTable from "../../../../Components/Table/CustomTable";
// import UserCreateByOperatorModal from "../../Modal/UserCreateByOperatorModal";
// import { useDispatch, useSelector } from "react-redux";
// import { setHeaderName } from "../../../../ReduxStore/Slices/headerSlice";
// import TableDataViewModal from "../../Modal/TableDataViewModal";
// import actions from "../../../../ReduxStore/actions";
// // import { setHeaderName } from './headerSlice';

// const TotalNetBankingPaymentReceived = ({ setHeaderTitleName }) => {
//   const dispatch = useDispatch();
//   const tableData = [
//     {
//       Name: "Vallarasu",
//       Email: "valla@gmail.com",
//       MobileNumber: "1232343444",
//       UserType: "Individual",
//       Status: "Approved",
//     },
//     {
//       Name: "Pravin",
//       Email: "pravin@gmail.com",
//       MobileNumber: "98787687687",
//       UserType: "Individual",
//       Status: "Approved",
//     },
//     {
//       Name: "Shahul",
//       Email: "shahul@gmail.com",
//       MobileNumber: "123322443543",
//       UserType: "Individual",
//       Status: "Approved",
//     },
//     {
//       Name: "Ramesh",
//       Email: "Ramesh@gmail.com",
//       MobileNumber: "76575675664",
//       UserType: "Individual",
//       Status: "Approved",
//     },
//     {
//       Name: "Sanjeev",
//       Email: "Sanjeev@gmail.com",
//       MobileNumber: "909878789709",
//       UserType: "Financial Consultant",
//       Status: "Pending",
//     },
//   ];

//   const sessionOperator_id = sessionStorage.getItem("sessionOperator_id");
//   const UserRole = sessionStorage.getItem("UserRole");

//   useEffect(() => {
//     // setHeaderTitleName("User Registration")
//     dispatch(setHeaderName("Total Payment Received"));
//   }, []);
//   const tableHeadData = [
//     "S.No",
//     // "Name",
//     "Customer Name",

//     "Scheme Bought",
//     "Value",
//     "Payment",
//     "Reap Status",
//   ];

//   // const tableHeadData = [
//   //   "S.No",
//   //   "Customer Id",
//   //   "Scheme Name",
//   //   "Order ID",
//   //   "Stake Starting",
//   //   "Stake Maturity",
//   //   "Lock-In",
//   //   "Value",
//   //   "Gold Staked",
//   //   // "Actions",
//   // ];

//   const { getNetBankingPurchasesByCreator } = useSelector(
//     (state) => state?.getNetBankingPurchasesByCreator
//   );

//   console.log(getNetBankingPurchasesByCreator, "getPurchasesByCreator");
//   useEffect(() => {
//     const data1 = {
//       data: {
//         createdByUserId: sessionOperator_id,
//         createdByUserRole: UserRole,
//       },
//       method: "get",
//       apiName: "getNetBankingPurchasesByCreator",
//     };

//     dispatch(actions.GETNETBANKINGPURCHASESBYCREATOR(data1));
//   }, [dispatch]);

//   const [rowTableData, setRowTableData] = useState([
//     {
//       //   customer_name: "--",
//       customer_name: "--",

//       purchase_id: "--",
//       title: "--",
//       purchase_id: "--",
//       stake_starting: "--",
//       stake_maturity: "--",
//       lock_in_months: "--",
//       value_of_purchase: "--",
//       purchase_stake: "--",
//     },
//   ]);
//   console.log(rowTableData, "rowTableDatarowTableData");
//   useEffect(() => {
//     const tempArr = [];
//     getNetBankingPurchasesByCreator?.data?.map((data, index) => {
//       return tempArr.push({
//         // Name: `${data?.first_name} ${data?.last_name}`,
//         // Email: data?.email,
//         // MobileNumber: data?.phone,
//         // UserType: data?.role,
//         // Status:
//         //   data?.approval_status === "pending"
//         //     ? "Pending"
//         //     : data?.approval_status === "approved"
//         //     ? "Approved"
//         //     : "Unknown", // Add a default case if needed
//         customer_name: `${data?.customer?.first_name} ${data?.customer?.last_name} `,
//         // customer_id:data?.customer_id,

//         scheme_bought: data?.title,
//         purchase_stake: `${data?.purchase_stake} g`,
//         value_of_purchase: `${data?.value_of_purchase} USD`,

//         reap_status:
//           data?.principle_gold_reaped_status.charAt(0).toUpperCase() +
//           data?.principle_gold_reaped_status.slice(1),
//       });
//     });
//     setRowTableData(tempArr);
//   }, [dispatch, getNetBankingPurchasesByCreator]);

//   return (
//     <Grid container spacing={2}>
//       <Grid item xs={12} sx={{ width: "100px" }}>
//         <CustomTable
//           tableData={rowTableData}
//           title="Cash Payment Received List"
//           tableHeadData={tableHeadData}
//           rowPerPage={10}
//           tableView="tableView"
//           tableSearch="tableSearch"
//           // dataCreate="dataCreate"
//           // tableEdit="tableEdit"
//           // tableDelete="tableDelete"
//           // modalName={UserCreateByOperatorModal}
//           allShowModal="allShowModal"
//           modalVeiwName={TableDataViewModal}
//           notModalTable="notModalTable"
//           modalViewHeadingName="User Detail"
//           modalHeadingName="Create User"
//         />
//       </Grid>
//     </Grid>
//   );
// };

// export default TotalNetBankingPaymentReceived;




import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import CustomTable from "../../../../Components/Table/CustomTable";
import UserCreateByOperatorModal from "../../Modal/UserCreateByOperatorModal";
import { useDispatch, useSelector } from "react-redux";
import { setHeaderName } from "../../../../ReduxStore/Slices/headerSlice";
import TableDataViewModal from "../../Modal/TableDataViewModal";
import actions from "../../../../ReduxStore/actions";
import PurchaseApprovalModalView from "../../../Management/PurchaseApproval/Modal/PurchaseApprovalModalView";
// import { setHeaderName } from './headerSlice';

const TotalNetBankingPaymentReceived = ({ setHeaderTitleName }) => {
  const dispatch = useDispatch();
  const tableData = [
    {
      Name: "Vallarasu",
      Email: "valla@gmail.com",
      MobileNumber: "1232343444",
      UserType: "Individual",
      Status: "Approved",
    },
    {
      Name: "Pravin",
      Email: "pravin@gmail.com",
      MobileNumber: "98787687687",
      UserType: "Individual",
      Status: "Approved",
    },
    {
      Name: "Shahul",
      Email: "shahul@gmail.com",
      MobileNumber: "123322443543",
      UserType: "Individual",
      Status: "Approved",
    },
    {
      Name: "Ramesh",
      Email: "Ramesh@gmail.com",
      MobileNumber: "76575675664",
      UserType: "Individual",
      Status: "Approved",
    },
    {
      Name: "Sanjeev",
      Email: "Sanjeev@gmail.com",
      MobileNumber: "909878789709",
      UserType: "Financial Consultant",
      Status: "Pending",
    },
  ];

  const sessionOperator_id = sessionStorage.getItem("sessionOperator_id");
  const UserRole = sessionStorage.getItem("UserRole");

  useEffect(() => {
    // setHeaderTitleName("User Registration")
    dispatch(setHeaderName("Total Payment Received"));
  }, []);
  const tableHeadData = [
    "S.No",
    // "Name",
    "Customer Name",

    "Scheme Bought",
    "Value",
    "Payment",
    "Reap Status",
  ];

  // const tableHeadData = [
  //   "S.No",
  //   "Customer Id",
  //   "Scheme Name",
  //   "Order ID",
  //   "Stake Starting",
  //   "Stake Maturity",
  //   "Lock-In",
  //   "Value",
  //   "Gold Staked",
  //   // "Actions",
  // ];

  const { getNetBankingPurchasesByCreator } = useSelector(
    (state) => state?.getNetBankingPurchasesByCreator
  );

  console.log(getNetBankingPurchasesByCreator, "getPurchasesByCreator");
  useEffect(() => {
    const data1 = {
      data: {
        createdByUserId: sessionOperator_id,
        createdByUserRole: UserRole,
      },
      method: "get",
      apiName: "getNetBankingPurchasesByCreator",
    };

    dispatch(actions.GETNETBANKINGPURCHASESBYCREATOR(data1));
  }, [dispatch]);

  const [rowTableData, setRowTableData] = useState([
    {
      //   customer_name: "--",
      customer_name: "--",

      purchase_id: "--",
      title: "--",
      purchase_id: "--",
      stake_starting: "--",
      stake_maturity: "--",
      lock_in_months: "--",
      value_of_purchase: "--",
      purchase_stake: "--",
    },
  ]);
  console.log(rowTableData, "rowTableDatarowTableData");
  useEffect(() => {
    const tempArr = [];
    getNetBankingPurchasesByCreator?.data?.map((data, index) => {
      return tempArr.push({
        // Name: `${data?.first_name} ${data?.last_name}`,
        // Email: data?.email,
        // MobileNumber: data?.phone,
        // UserType: data?.role,
        // Status:
        //   data?.approval_status === "pending"
        //     ? "Pending"
        //     : data?.approval_status === "approved"
        //     ? "Approved"
        //     : "Unknown", // Add a default case if needed
        customer_name: `${data?.customer?.first_name} ${data?.customer?.last_name} `,
        // customer_id:data?.customer_id,
        purchase_id: data?.purchase_id,
        scheme_bought: data?.title,
        purchase_stake: `${data?.purchase_stake} g`,
        value_of_purchase: `${data?.value_of_purchase} USD`,

        reap_status:
          data?.principle_gold_reaped_status.charAt(0).toUpperCase() +
          data?.principle_gold_reaped_status.slice(1),
      });
    });
    setRowTableData(tempArr);
  }, [dispatch, getNetBankingPurchasesByCreator]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sx={{ width: "100px" }}>
        <CustomTable
          tableData={rowTableData}
          title="Cash Payment Received List"
          tableHeadData={tableHeadData}
          rowPerPage={10}
          tableView="tableView"
          tableSearch="tableSearch"
          // dataCreate="dataCreate"
          // tableEdit="tableEdit"
          // tableDelete="tableDelete"
          // modalName={UserCreateByOperatorModal}
          // allShowModal="allShowModal"
          modalVeiwName={PurchaseApprovalModalView}
          notModalTable="notModalTable"
          modalViewHeadingName="User Detail"
          modalHeadingName="Create User"
        />
      </Grid>
    </Grid>
  );
};

export default TotalNetBankingPaymentReceived;
